import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.CREATE_EMPLOYEE:
    case actions.ADJUST_MEMBERSHIP_LEVEL:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_EMPLOYEE_ENDED:
    case actions.ADJUST_MEMBERSHIP_LEVEL_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_MEMBERS:
    case actions.FIND_MEMBER:
    case actions.SEARCH_MEMBER_ATTRIBUTES:
    case actions.FIND_MEMBER_ATTRIBUTE:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_MEMBERS_ENDED:
    case actions.FIND_MEMBER_ENDED:
    case actions.SEARCH_MEMBER_ATTRIBUTES_ENDED:
    case actions.FIND_MEMBER_ATTRIBUTE_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_MEMBER_ATTRIBUTE:
    case actions.UPDATE_MEMBER:
    case actions.UNMASK_PROFILE:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_MEMBER_ATTRIBUTE_ENDED:
    case actions.UPDATE_MEMBER_ENDED:
    case actions.UNMASK_PROFILE_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    default:
      return state;
  }
};
